import type { NavigateFunction } from 'react-router-dom';

let navigateFn: NavigateFunction | undefined;

export const setNavigator = (navigator: NavigateFunction) => {
  navigateFn = navigator;
};

export const navigation: NavigateFunction = ((
  ...args: Parameters<NavigateFunction>
): ReturnType<NavigateFunction> => {
  if (!navigateFn) {
    throw new Error('Navigation attempted before router initialized');
  }
  return navigateFn(...args);
}) as NavigateFunction;
